import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'src/shared/types/server-page-interface'
import { migrateCommand } from 'tools/commands/migrate/utils/migrateCommand'
import { migrateCoupon } from './migrate-coupon'

export default function migrateCouponCommand(page: ServerPage) {
  return migrateCommand({
    page,
    structureType: structureTypes.COUPON,
    migrateFunction: migrateCoupon,
  })
}
